import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TasksAwardsOfficeSignoff } from 'containers/pages'
import { meta, routerAdapter } from 'helpers/decorators'

@meta({
  title: 'Participant awards',
  noOverride: true
})
@routerAdapter()
class ParticipantAwardSinglePage extends Component {
  static propTypes = {
    params: PropTypes.object.isRequired
  }
  render() {
    const { params } = this.props

    return (
      <TasksAwardsOfficeSignoff
        params={params}
        decoFilter="participantAwards"
      />
    )
  }
}

export default ParticipantAwardSinglePage
